export default function stopPropagation(e: Event) {
    return e.stopPropagation()
}